import { SubscriberId } from "../../app/services/subscriberFeedbackApi";

export const ARCHIVE_SUBSCRIBER_ID: SubscriberId = "9A375F81-708D-44E5-A5F7-CA5C11478AB7";

export function isArchiveSubscriber(subscriberId: SubscriberId): boolean {
    return ARCHIVE_SUBSCRIBER_ID.localeCompare(subscriberId) === 0;
}
